import { GET_PRODUCT_TAXONOMY } from "../constants/endpoints";
import axiosClient from "./axios";

class fetchTaxonomy {
  static async getTaxonomy() {
    return await axiosClient.get(GET_PRODUCT_TAXONOMY);
  }
}

export default fetchTaxonomy;
